export default {
  path: '/lvy-let-sign-privacy',
  component: () => import('./LVYLetSignPrivacy'),
  meta: {
    title: '电子牵隐私政策',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}